export default "__VITE_ASSET__F4FQVtV0__"